export const DEFAULT_CURRENCY = 'USD';
export const EMPTY_LIST = [];
export const EMPTY_MAP: Record<string, unknown> = {};
export const MAX_URL_LENGTH = 2000;
export const MGMT_API_BASE_URL = '/ox/4.0';
export const APIGEE_MGMT_API_BASE_URL = '/apigee/ox/4.0/';

/**
 * MGMT API package writes (create, update, clone) made with `new` take contextual segments from
 * `targeting.contextual_segment` and regenerate the deprecated `ctx_` custom variables from it.
 * Without it MGMT ignores `contextual_segment`.
 * Reads still use the default format, which returns both; `packageToFormState` drops the `ctx_` variables itself,
 * which is what a `new` read would do on the backend (see the ox-api-core ADR on contextual_segment_format).
 */
export const CONTEXTUAL_SEGMENT_FORMAT_PARAMS = { contextual_segment_format: 'new' } as const;
